import { PERMISSION_OBJ_DOCUMENT_IMPORT, PERMISSION_READ } from '@/constants/permissions';

import { WaybillImports } from './page';

// Sibling, not child, of `base-layout.waybills` — the page owns the entire
// base-layout outlet. As a child it would render under the waybills table.
export const states = [
  {
    name: 'base-layout.waybill-imports',
    url: '/waybill-imports',
    component: WaybillImports,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_DOCUMENT_IMPORT, PERMISSION_READ]],
    },
  },
];
